import * as models from "app/models/requireme";

/**Estado global de la aplicación. Se utiliza en la parte de globales. Este estado persiste en el dispositivo */
export interface State {
    documentacion: models.DocumentacionModel,
    cotizacion: models.CotizadorModel,
    ocurre: models.EntregaOcurreModel;
    liberacionZE: models.LiberacionEntregaZEModel;
    ultimaLecturaCargaDescargaRuta: models.UltimaLecturaFolioFisico | null;
    ultimaLecturaCargaDescargaEAD: models.UltimaLecturaFolioFisico | null;
    ultimaLecturaCargaZE: models.UltimaLecturaFolioFisico | null;
    ultimaLecturaDescargaZE: models.UltimaLecturaFolioFisico | null;
    viajeApp: models.ViajeAppIniciado | null;
    viajeZEApp: models.ViajeZEAppIniciado | null;
    rastreo: models.RastreoModel | null;
    facturacionOnline: models.FacturacionOnlineParametros | null;
    filtroGuias: models.FiltroGuia;
    filtroGuiasConsultaZE: models.FiltroGuiasSucursalZE;
    filtroFacturas: models.FiltroFacturas;
    filtroSaldosUsuarioZE: models.FiltroSaldosUsuariosZE;
    idUsuarioZEConsultaSaldo: number | null;
    filtroREP: models.FiltroRep;
};

/**Estado inicial de la aplicación */
export const initial: State = {
    documentacion: models.documentacionModelInicial,
    cotizacion: models.cotizadorInicial,
    ocurre: models.ocurreModelInicial,
    liberacionZE: models.liberacionEntregaZEModelInicial,
    ultimaLecturaCargaDescargaRuta: null,
    ultimaLecturaCargaDescargaEAD: null,
    ultimaLecturaCargaZE: null,
    ultimaLecturaDescargaZE: null,
    viajeApp: null,
    viajeZEApp: null,
    rastreo: null,
    idUsuarioZEConsultaSaldo: null,
    facturacionOnline: null,
    filtroGuias: { Limite: 100 },
    filtroGuiasConsultaZE: { Limite: 100 },
    filtroFacturas: { Limite: 500, EsREP: false },
    filtroSaldosUsuarioZE: {},
    filtroREP: { Limite: 500 },
};



// WEBPACK FOOTER //
// ./app/resources/state.ts